// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3n-2";
export var cell = "_3n-6";
export var cellContainer = "_3n-3";
export var disabled = "_3n-5";
export var featuredIconCellContainer = "_3n-7";
export var featuredIconTextContainer = "_3n-9";
export var featuredIconWrapper = "_3n-8";
export var hasRowsSelected = "_88-1";
export var noBorder = "_3n-a";
export var overflowableText = "_3n-0";
export var overflowableTextContainer = "_3n-1";
export var row = "_3p-0";
export var rowCheckboxCell = "_3n-4";
export var selectableTable = "_88-2";